// extracted by mini-css-extract-plugin
export default {"video":"VideoPreview_video__c3RUA"};